import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/articles';
import { siteInfo } from '@/mocks/siteInfo';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-md border-b border-secondary-200/60">
      <nav className="max-w-[1280px] mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl">{siteInfo.logo}</span>
            <span className="text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors duration-200 whitespace-nowrap">
              {siteInfo.name}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-secondary-100'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive(`/category/${cat.slug}`)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-secondary-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-secondary-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg hover:bg-secondary-100 transition-colors cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label={mobileOpen ? '关闭菜单' : '打开菜单'}
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-secondary-200/40 pt-3 animate-in slide-in-from-top-2">
            <div className="flex flex-col gap-1">
              <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-secondary-100 transition-colors whitespace-nowrap" onClick={() => setMobileOpen(false)}>
                首页
              </Link>
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-secondary-100 transition-colors whitespace-nowrap"
                  onClick={() => setMobileOpen(false)}
                >
                  {cat.name}
                </Link>
              ))}
              <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-secondary-100 transition-colors whitespace-nowrap" onClick={() => setMobileOpen(false)}>
                关于我们
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}